import { DealItem, PricingMode } from '@/lib/graphql/generated/graphql';

const BULK_CHILDREN_EDITABLE_FIELDS = new Set<keyof DealItem>([
  'name',
  'listPrice',
  'discountedPrice',
  'chooseDiscount',
  'choosePrice',
  'buyingPrice',
  'marginPercentage',
  'shippingPrice',
  'eeePrice',
  'couponExpirationDate',
  'madeIn',
  'sourceUrl',
]);

export function isBulkChildrenEditableField(
  field: string,
  pricingMode?: PricingMode
): field is keyof DealItem {
  if (
    field === 'buyingPrice' &&
    pricingMode !== undefined &&
    pricingMode !== PricingMode.BuyingPriceFixed
  ) {
    return false;
  }

  if (
    field === 'marginPercentage' &&
    pricingMode !== undefined &&
    pricingMode !== PricingMode.MarginFixed
  ) {
    return false;
  }

  return BULK_CHILDREN_EDITABLE_FIELDS.has(field as keyof DealItem);
}
